/** 订单创建/编辑表单的行状态与请求体构造（S12/F6）。 */

export interface OrderFormLine {
  readonly key: string;
  productId: string | null;
  productLabel: string;
  qty: string;
  unitId: string;
}

export const emptyOrderLine = (): OrderFormLine => ({
  key: crypto.randomUUID(),
  productId: null,
  productLabel: '',
  qty: '',
  unitId: '',
});

export interface OrderFormMeta {
  readonly requiredDate: string;
  readonly customerRefText: string;
  readonly notes: string;
}

/**
 * 创建/PATCH 共用同一个请求体构造——与 buildTransferBody 同一模式，抽成
 * 纯函数以便直接测试"表单状态 → 请求体"这条映射，不需要通过渲染交互间接验证。
 */
export function buildOrderBody(
  meta: OrderFormMeta,
  lines: readonly OrderFormLine[],
): Record<string, unknown> {
  return {
    requiredDate: meta.requiredDate.trim() || undefined,
    customerRefText: meta.customerRefText.trim() || undefined,
    notes: meta.notes.trim() || undefined,
    lines: lines.map((l) => ({
      productId: l.productId,
      quantity: { value: l.qty.trim(), unitId: l.unitId },
    })),
  };
}

export function orderLinesValid(lines: readonly OrderFormLine[]): boolean {
  return lines.length > 0 && lines.every((l) => l.productId && l.qty.trim() && l.unitId);
}
